import { Form } from "react-bootstrap";
import { useFormikContext, useField } from "formik";

const Input = ({
  name,
  title,
  placeholder,
  disabled,
  required,
  onBlur,
  errorFromBackend
}) => {
  const { handleChange, setFieldTouched, handleBlur } = useFormikContext(name);
  const [field, meta] = useField({
    name
  });

  return (
    <Form.Group className="mb-3">
      {title ? (
        <Form.Label className="mb-1">{`${title}${required ? "*" : ""
          }`}</Form.Label>
      ) : (
        ""
      )}
      <Form.Control
        className="information-placeholder"
        type="text"
        name={name}
        placeholder={placeholder || ""}
        onChange={handleChange}
        onFocus={() => setFieldTouched(name)}
        onBlur={(e) => {
          handleBlur(e);
          onBlur && onBlur(e);
        }}
        value={field.value || ""}
        isInvalid={meta.error && meta.touched}
        disabled={disabled}
      />
      {meta.error && meta.touched ? (
        <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
      ) : errorFromBackend ? (
        <div className="form-error mb-2">{errorFromBackend}</div>
      ) : null}
    </Form.Group>
  );
};

export default Input;
